import { z } from 'zod';

export const makeDATOriginDataSchema = () => {
  return z.object({
    datOriginMCI: z.string().optional(),
    datOriginMCIDescr: z.string().optional(),
    datOriginLTR: z.string().optional(),
    datOriginFMCI: z.string().optional(),
    datOriginFMCIDescr: z.string().optional(),
  });
};

const DATOriginDataSchema = makeDATOriginDataSchema();
export type DATOriginData = z.infer<typeof DATOriginDataSchema>;
